import React from "react";
import Card from "react-bootstrap/Card";

function ProjectCards(props) {
  return (
    <a
      href={props.demoLink}
      target="_blank"
      rel="noreferrer"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Card className="project-card-view" style={{ cursor: "pointer", transition: "transform 0.2s" }}>
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>
          {"\n"}
          {"\n"}
        </Card.Body>
      </Card>
    </a>
  );
}
export default ProjectCards;
